import { Restore, Check } from "@mui/icons-material";
import { Button, MenuItem, Tab, Tabs, TextField, Typography } from "@mui/material";
import { useState } from "react";
// import { ReactGrid } from "@silevis/reactgrid";
import ReactGrid from "../ReactGridComponent";
// import "@silevis/reactgrid/styles.css";
import { useTheme } from "@mui/styles";

export const RTFOPadPerfSchedule = ({ wells, perfSchedule, setPerfSchedule, darkMode }) => {

  const theme = useTheme();

  const headerRow = {
    rowId: "header",
    cells: [
      { type: "header", text: "Stage Number" },
      { type: "header", text: "Cluster Number" },
      { type: "header", text: "Shot Depth (m)" },
      { type: "header", text: "Number of Shots" },
      { type: "header", text: "Entry Hole Diameter (in)" },
      { type: "header", text: "Proppant Intensity (ton/m)" },
      { type: "header", text: "Seismicity Risk" }
    ]
  };

  const getColumns = () => [
    { columnId: "stageNumber", width: 150 },
    { columnId: "clusterNumber", width: 150 },
    { columnId: "shotDepth", width: 150 },
    { columnId: "numberOfShots", width: 150 },
    { columnId: "entryHoleDiameter", width: 150 },
    { columnId: "tpm", width: 150 },
    { columnId: "seismicRisk", width: 150 }
  ];

  const wellNames = wells?.map(well => well.name);

  const [tabItem, setTabItem] = useState(0);
  const [completionType, setCompletionType] = useState(perfSchedule?.wells?.[wellNames?.[tabItem]]?.completionType || 'plugAndPerf');
  const [isModified, setIsModified] = useState(false);


  const [data, setData] = useState(() => {
    const wellPerfScheduleArray = convertPerfScheduleToArray(tabItem);

    const perfScheduleData = [];

    for (let i = 0; i < 1000; i++) {
      const row = wellPerfScheduleArray?.[i];

      perfScheduleData.push({
        stageNumber: row?.[0] || null,
        clusterNumber: row?.[1] || null,
        shotDepth: row?.[2] || null,
        numberOfShots: row?.[3] || null,
        entryHoleDiameter: row?.[4] || null,
        tpm: row?.[5] || null,
        seismicRisk: row?.[6] || null
      });
    };

    return perfScheduleData;
  });

  const getRows = (data) => [
    headerRow,
    ...data.map((row, idx) => ({
      rowId: idx,
      cells: [
        { type: "number", value: row.stageNumber },
        { type: "number", value: row.clusterNumber },
        { type: "number", value: row.shotDepth },
        { type: "number", value: row.numberOfShots },
        { type: "number", value: row.entryHoleDiameter },
        { type: "number", value: row.tpm },
        { type: "number", value: row.seismicRisk }
      ]
    }))
  ];

  const rows = getRows(data);
  const columns = getColumns();

  const applyChangesToData = (changes, prevData) => {
    changes.forEach((change) => {
      const dataIndex = change.rowId;
      const fieldName = change.columnId;
      prevData[dataIndex][fieldName] = change.newCell.value;

      const stageNumber = prevData?.[dataIndex]?.stageNumber;

      if (fieldName === 'tpm') {
        for (let i = 0; i < prevData?.length; i++) {
          if (prevData[i]?.stageNumber === stageNumber) {
            prevData[i].tpm = change.newCell.value;
          } else if (prevData[i]?.stageNumber > stageNumber) {
            break;
          };
        };
      } else if (fieldName === 'seismicRisk') {
        for (let i = 0; i < prevData?.length; i++) {
          if (prevData[i]?.stageNumber === stageNumber) {
            prevData[i].seismicRisk = change.newCell.value;
          } else if (prevData[i]?.stageNumber > stageNumber) {
            break;
          };
        };
      };

    });
    return [...prevData];
  };

  const handleChanges = (changes) => {
    setData((prevData) => applyChangesToData(changes, prevData));
    setIsModified(true);
  };

  try {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', position: 'relative', overflow: 'hidden' }}>
        <div>
          <Tabs
            value={tabItem}
            onChange={(e, value) => handleTabChange(value)}
            style={{ borderBottom: '1px solid lightgrey', marginBottom: 20 }}
            textColor={darkMode ? "inherit" : "primary"}
            TabIndicatorProps={{ style: { background: (darkMode ? '#fff' : theme?.palette?.primary?.main) } }}
          >
            {wells?.map(well => {
              return (<Tab label={well.name} key={well.uwi || well.name} />)
            })}
          </Tabs>

          <div style={{ marginBottom: 20 }}>
            <Button
              variant="contained"
              size="small"
              startIcon={<Check />}
              onClick={handleSaveClick}
              style={{ marginRight: 20, color: darkMode ? '#000' : '#fff', backgroundColor: darkMode ? "#fff" : theme.palette.primary.main }}
              disabled={!isModified}
            >
              Save Schedule
            </Button>
            <Button
              variant="outlined"
              size="small"
              startIcon={<Restore />}
              onClick={handleResetClick}
              style={{
                color: (darkMode ? '#fff' : theme.palette.primary.main),
                borderColor: (darkMode ? '#fff' : theme.palette.primary.main)
              }}
            >
              Reset
            </Button>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '47%', marginBottom: 20 }}>
            <Typography fontSize="14px">Completion Type</Typography>
            <TextField
              margin="dense"
              size="small"
              select
              value={completionType}
              variant="outlined"
              fullWidth
              onChange={e => setCompletionType(e.target.value)}
            >
              {['plugAndPerf', 'coil', 'ball', 'dart'].map((option) => (
                <MenuItem key={option + '-key'} value={option}>
                  {getCompletionTypeName(option)}
                </MenuItem>
              ))}
            </TextField>
          </div>
        </div>

        <ReactGrid
          divProps={{
            style: {
              maxHeight: 900,
              overflow: "scroll"
            }
          }}
          rows={rows}
          columns={columns}
          onCellsChanged={handleChanges}
          enableRangeSelection
          enableFillHandle
          stickyTopRows={1}
        />
      </div>
    );
  } catch (error) {
    console.log(error);
    return <></>;
  };

  function getCompletionTypeName(completionType) {
    switch (completionType) {
      case 'plugAndPerf':
        return 'Plug And Perf';
      case 'coil':
        return 'Coiled Tubing';
      case 'ball':
        return 'Ball Drop';
      case 'dart':
        return 'Dart Drop';
      default:
        return '';
    };
  };

  function handleTabChange(newTabItem) {
    try {
      if (newTabItem >= 0) {
        setTabItem(newTabItem)

        const wellPerfScheduleArray = convertPerfScheduleToArray(newTabItem);

        const perfScheduleData = [];

        for (let i = 0; i < 1000; i++) {
          const row = wellPerfScheduleArray?.[i];

          perfScheduleData.push({
            stageNumber: row?.[0] || null,
            clusterNumber: row?.[1] || null,
            shotDepth: row?.[2] || null,
            numberOfShots: row?.[3] || null,
            entryHoleDiameter: row?.[4] || null,
            tpm: row?.[5] || null,
            seismicRisk: row?.[6] || null
          });
        };

        setData(() => perfScheduleData);
        setIsModified(false);
      };

    } catch (error) {
      console.log(error);
      return;
    };
  };

  function handleSaveClick() {
    try {
      const wellPerfSchedule = { stages: {}, tvd: wells?.find(well => well.name === wellNames?.[tabItem])?.tvd, completionType };

      for (let i = 0; i < data?.length; i++) {
        const row = data[i];

        const stageNumber = Number(row?.stageNumber);
        const clusterNumber = Number(row?.clusterNumber);

        if (!stageNumber > 0 || !clusterNumber > 0) continue;
        if (!wellPerfSchedule.stages[stageNumber]) wellPerfSchedule.stages[stageNumber] = { clusters: {}, tpm: Number(row?.tpm || 0), seismicRisk: Number(row?.seismicRisk || 0) };
        wellPerfSchedule.stages[stageNumber].clusters[clusterNumber] = { shotDepth: Number(row?.shotDepth || 0), numShots: Number(row?.numberOfShots || 0), entryHoleDiameter: Number(row?.entryHoleDiameter || 0) };
      };

      const newPerfSchedule = JSON.parse(JSON.stringify(perfSchedule));
      newPerfSchedule.wells[wellNames?.[tabItem]] = wellPerfSchedule;
      setPerfSchedule(() => newPerfSchedule);
      setIsModified(false);

    } catch (error) {
      console.log(error);
    };
  };

  function convertPerfScheduleToArray(tabItem) {
    try {
      const data = [];

      const wellPerfSchedule = perfSchedule?.wells[wellNames?.[tabItem]];
      const stageNumbers = wellPerfSchedule?.stages ? Object.keys(wellPerfSchedule.stages) : [];
      for (const stageNumber of stageNumbers) {
        const clusterNumbers = wellPerfSchedule?.stages?.[stageNumber]?.clusters ? Object.keys(wellPerfSchedule?.stages?.[stageNumber]?.clusters) : [];
        for (const clusterNumber of clusterNumbers) {
          data.push([
            Number(stageNumber),
            Number(clusterNumber),
            Number(wellPerfSchedule.stages[stageNumber].clusters[clusterNumber]?.shotDepth),
            Number(wellPerfSchedule.stages[stageNumber].clusters[clusterNumber]?.numShots),
            Number(wellPerfSchedule.stages[stageNumber].clusters[clusterNumber]?.entryHoleDiameter),
            Number(wellPerfSchedule.stages[stageNumber]?.tpm),
            Number(wellPerfSchedule.stages[stageNumber]?.seismicRisk)
          ])
        };
      };

      return data;

    } catch (error) {
      console.log(error);
      return [];
    };
  };

  function handleResetClick() {
    try {
      const wellPerfScheduleArray = convertPerfScheduleToArray(tabItem);

      const perfScheduleData = [];

      for (let i = 0; i < 1000; i++) {
        const row = wellPerfScheduleArray?.[i];

        perfScheduleData.push({
          stageNumber: row?.[0] || null,
          clusterNumber: row?.[1] || null,
          shotDepth: row?.[2] || null,
          numberOfShots: row?.[3] || null,
          entryHoleDiameter: row?.[4] || null,
          tpm: row?.[5] || null,
          seismicRisk: row?.[6] || null
        });
      };

      setData(() => perfScheduleData);
      setIsModified(false);

    } catch (error) {
      console.log(error);
      return;
    };
  };
};
